import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Input from '@material-ui/core/Input';

import './trainingForm.css'
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
export default function TrainingForm(props) {

    const [date, setDate] = useState(new Date())
    const [start, setStart] = useState('')
    const [end, setEnd] = useState('')
    const [court, setCourt] = useState([])
    const [nb_time, setNbTime] = useState(1)

    const list_court = [{ id: 1, name: 'Terrain exterieur 1' },
    { id: 3, name: 'Terrain exterieur 2' },
    { id: 5, name: 'Terrain exterieur 3' },
    { id: 7, name: 'Terrain exterieur 4' },
    { id: 8, name: 'Terrain exterieur BM 1' },
    { id: 9, name: 'Terrain exterieur BM 2' },
    { id: 10, name: 'Terrain intérieur 5' },
    { id: 11, name: 'Terrain intérieur 6' }
    ]

    const [textReturn, setTextReturn] = useState('')

    var addEntrainement = function () {
        setTextReturn('En cours ...')
        for (let i = 0; i < nb_time; i++) {
            let new_date = new Date(date)
            if (i != 0)
                new_date = new_date.setDate(new_date.getDate() + i * 7)
            fetch("https://playattitude.fr/admin/addEntrainement", {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*'
                },
                body: JSON.stringify({ date: formatDate(new_date), start, end,list_court:court, token: localStorage.getItem('web_bm') })
            })
                .then(res => res.json())
                .then(res => {
                    if (res.message)
                        setTextReturn(res.message)
                })
        }
    }

    var removeEntrainement = function () {
        setTextReturn('En cours ...')
        for (let i = 0; i < nb_time; i++) {
            let new_date = new Date(date)
            if (i != 0)
                new_date = new_date.setDate(new_date.getDate() + i * 7)
            fetch("https://playattitude.fr/admin/removeEntrainement", {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*'
                },
                body: JSON.stringify({ date: formatDate(new_date), start, end,list_court:court, token: localStorage.getItem('web_bm') })
            })
                .then(res => res.json())
                .then(res => {
                    if (res.message)
                        setTextReturn(res.message)
                })
        }
    }

    var formatDate = function (date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return [year, month, day].join('-');
    }

    const handleChange = (event) => {
        setCourt(event.target.value);
      };

    return (
        <div className="center trainingForm">
            <h2>Bloquer des créneaux</h2>
            <form noValidate autoComplete="off">
                <div>
                    <TextField
                        id="date"
                        label="Date"
                        type="date"
                        defaultValue="2017-05-24"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        value={date}
                        onChange={(event) => setDate(event.target.value)}
                    />
                </div><br />
                <div >
                    <TextField type="number" id="standard-basic" label="Heure de début (ex : 13 pour 13h)" value={start} onChange={(event) => setStart(event.target.value)} />
                </div><br />
                <div >
                    <TextField type="number" id="standard-basic" label="Heure de fin (ex : 13 pour 13h)" value={end} onChange={(event) => setEnd(event.target.value)} />
                </div><br />
                <div >
                    <Select
                        placeholder="Terrain"
                        labelId="demo-mutiple-name-label"
                        id="demo-mutiple-name"
                        multiple
                        value={court}
                        onChange={handleChange}
                        input={<Input />}
                        MenuProps={MenuProps}
                    >
                        {list_court.map((court) => (
                            <MenuItem key={court.id} value={court.id}>
                                {court.name}
                            </MenuItem>
                        ))}
                    </Select>
                </div><br />
                <div >
                    <TextField type="number" id="standard-basic" label="Répéter sur X semaines" value={nb_time} onChange={(event) => setNbTime(event.target.value)} />
                </div><br />
                <div>
                    <Button variant="contained" onClick={() => addEntrainement()}>Bloquer</Button>
                </div>
                {/* <div>
                    <Button variant="contained" onClick={() => removeEntrainement()}>Libérer</Button>
                </div> */}
            </form>
            <div><p>{textReturn}</p></div>
        </div>
    );
}